<template>
  <div class="content" v-if="loadOrganisationSettings">
    <base-header class="pb-6">
    </base-header>
    <b-container fluid class="mt--6">
      <card class="bg-transparent" >
        <template slot="header">
          <div style="display: flex;">
            <div>
              <h3 class="mb-0">Organisation settings</h3>
              <p class="text-sm mb-0">
                Settings related to this organisation
              </p>
            </div>
          </div>
        </template>
        <div>
          <b-row v-if="!editSettings">
            <b-col cols="12">
              <b-card no-body>
                <b-card-header>
                  <h5 class="h3 mb-0">Settings</h5>
                  <div style="flex: 1.5;">
                    <base-button size="sm" type="neutral" v-if="!editSettings" @click.native="handleEditSettings()" style="float: right;">Edit</base-button>
                  </div>
                </b-card-header>
                <b-card-body v-if="organisationSettings">
                  <h6 class="h3 mb-0">Push integrations</h6>
                  <div v-if="!organisationSettings.pushIntegrationSettings">
                    <p/>
                    <b>none</b>
                    <p/>
                  </div>
                  <div v-if="organisationSettings.pushIntegrationSettings" v-for="push in organisationSettings.pushIntegrationSettings">
                    <hr/>
                    <div>
                      Active : <b>{{ getBoolean(push.active) }}</b>
                    </div>
                    <p/>
                    <div>
                      Push server : <b>{{ push.server }}</b>
                    </div>
                    <div v-if="push.server === 'EasyTrack'">
                      Remote organisation : <b>{{ push.remoteOrganisation }}</b>
                    </div>
                    <div v-if="push.server === 'EasyTrack'">
                      Asset trip reports : <b>{{ getBoolean(push.assetTripReports) }}</b>
                    </div>
                    <div v-if="push.server === 'NVD'">
                      Alarms : <b>{{ getBoolean(push.alarms) }}</b>
                    </div>
                  </div>
                  <div v-else>
                    Push integration is <b>disabled</b>
                  </div>
                </b-card-body>
                <b-card-body v-else >
                  No organisation settings available
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="editSettings">
            <b-col cols="12">
              <b-card no-body>
                <b-card-header>
                  <h5 class="h3 mb-0">Edit settings</h5>
                </b-card-header>
                <b-card-body>
                  <form>
                    <b-container fluid="xl">
                      <b-row>
                        <b-col cols="3">
                          <b>Push integrations</b>
                          <p/>
                          <div v-for="(form_push, form_idx) in organisationSettings.pushIntegrationSettings">
                            <hr/>
                            <div align="right">
                              <base-button size="sm" type="neutral" @click.native="handleRemovePushIntegration(form_idx)">-</base-button>
                            </div>
                            <div>
                              <base-input label="Active">
                                <b-form-checkbox class="mb-3" v-model="form_push.active" />
                              </base-input>
                            </div>
                            <div>
                              <base-input label="Push server">
                                <el-select width="120"
                                           filterable
                                           placeholder="Servers"
                                           v-model="form_push.server"
                                           @change="handleServerChange(form_idx)"
                                           :required=true>
                                  <el-option key="EasyTrack" label="EasyTrack" value="EasyTrack" />
                                  <el-option key="NVD" label="NVD" value="NVD" />
                                </el-select>
                              </base-input>
                            </div>
                            <div>
                              <base-input label="Remote organisation" v-model="form_push.remoteOrganisation" v-if="form_push.server === 'EasyTrack'" />
                            </div>
                            <div>
                              <base-input label="Asset trip reports" v-if="form_push.server === 'EasyTrack'">
                                <b-form-checkbox class="mb-3" v-model="form_push.assetTripReports" :disabled="true" />
                              </base-input>
                            </div>
                            <div>
                              <base-input label="Alarms" v-if="form_push.server === 'NVD'">
                                <b-form-checkbox class="mb-3" v-model="form_push.alarms" :disabled="true" />
                              </base-input>
                            </div>
                          </div>
                          <div align="right">
                            <base-button size="sm" type="neutral" @click.native="handleAddPushIntegration">+</base-button>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="1">
                          <div>
                            <base-button size="sm" type="neutral" @click.native="handleSaveSettings">Save</base-button>
                            <base-button size="sm" type="neutral" @click.native="handleCancelSettings">Cancel</base-button>
                          </div>
                        </b-col>
                      </b-row>
                    </b-container>
                  </form>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </card>
    </b-container>
  </div>
</template>

<script>
import {Option, Select} from "element-ui";
import crudApi from "../../crud/crud-api";

export default {
  name: "OrganisationSettings",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data: _ => ({
    organisationSettings: undefined,
    editSettings: false
  }),
  methods: {
    getOrganisationSettings() {
      crudApi.getOrganisationSettings(this.$store.state.auth.user.organisation_id).then(json => this.organisationSettings = json.data ? json.data : json).catch(error => this.organisationSettings = error.response.status === 404 ? undefined : this.organisationSettings);
    },
    handleEditSettings() {
      if (!this.organisationSettings) {
        this.organisationSettings = {
          deleted: false,
          pushIntegrationSettings: undefined
        }
      }

      this.editSettings = true
    },
    handleSaveSettings() {
      if (this.organisationSettings.pushIntegrationSettings && this.organisationSettings.pushIntegrationSettings.length === 0) {
        this.organisationSettings.pushIntegrationSettings = null
      }

      if (!this.organisationSettings.id) {
        crudApi.createOrganisationSettings(this.$store.state.auth.user.organisation_id, this.organisationSettings).then(json => this.organisationSettings.id = json.data ? json.data._id : json._id)
      } else {
        crudApi.updateOrganisationSettings(this.organisationSettings)
      }

      this.editSettings = false
    },
    handleCancelSettings() {
      this.getOrganisationSettings()

      new Promise(resolve => setTimeout(resolve, 100)).then(() => this.editSettings = false);
    },
    handleAddPushIntegration() {
      if (!this.organisationSettings.pushIntegrationSettings) {
        this.organisationSettings.pushIntegrationSettings = [{
          active: true,
          server: "EasyTrack",
          remoteOrganisation: "",
          assetTripReports: true,
          alarms: false
        }]
      } else {
        this.organisationSettings.pushIntegrationSettings.push({
          active: true,
          server: "EasyTrack",
          remoteOrganisation: "",
          assetTripReports: true,
          alarms: false
        })
      }
    },
    handleRemovePushIntegration(index) {
      if (this.organisationSettings.pushIntegrationSettings) {
        this.organisationSettings.pushIntegrationSettings.splice(index, 1)
      }
    },
    handleServerChange(index) {
      if (this.organisationSettings.pushIntegrationSettings && this.organisationSettings.pushIntegrationSettings[index]) {
        let server = this.organisationSettings.pushIntegrationSettings[index].server

        if (server === "EasyTrack") {
          this.organisationSettings.pushIntegrationSettings[index].assetTripReports = true
          this.organisationSettings.pushIntegrationSettings[index].alarms = false
        } else if (server === "NVD") {
          this.organisationSettings.pushIntegrationSettings[index].assetTripReports = false
          this.organisationSettings.pushIntegrationSettings[index].alarms = true
        }
      }
    },
    getBoolean(val) {
      if (!val) return false
      else {
        if (val === true) return true
      }

      return false
    }
  },
  computed: {
    loadOrganisationSettings() {
      this.getOrganisationSettings()

      return true
    },
  }
}

</script>

<style scoped>

</style>
